import React from 'react';
import './Button.css';

export interface ButtonProps {
  label: string;
  onClick: () => void;
  style?: React.CSSProperties;
  disabled?: boolean;
  variant?: 'primary' | 'secondary' | 'outline' | 'ghost';
  className?: string;
  icon?: React.ReactNode;
}

export default function Button({
  label,
  onClick,
  style,
  disabled,
  variant = 'primary',
  className = '',
  icon
}: ButtonProps) {
  const variantClass = variant !== 'primary' ? `btn-${variant}` : '';

  return (
    <button
      onClick={onClick}
      disabled={disabled}
      style={style}
      className={`premium-btn ${variantClass} ${className}`.trim()}
    >
      <span>{label}</span>
      {icon && <span className="btn-icon">{icon}</span>}
    </button>
  );
}
